import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import styles from './HeaderMenu.module.scss';

import HamburgerIcon from '../HamburgerIcon/HamburgerIcon';
import Button from '../Button/Button';
import AddToCalendarButtons from '../AddToCalendarButtons/AddToCalendarButtons';

import Logo from '../Logo/Logo';

import { isMobile, isTablet } from "react-device-detect";

const HeaderMenu = () => {
    const menu = useRef(null)
    const location = useLocation();
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        setOpened(false);
    }, [location]);

    useEffect(() => {
        const closeMenu = (e) => {
            if(opened && !menu.current?.contains(e.target)){
                setOpened(false)
            }
        }

        opened && document.addEventListener('mousedown', closeMenu);

        return () => document.removeEventListener('mousedown', closeMenu)
    }, [opened]);

    const handlenavToggleClick = () => {
        setOpened(prevState => !prevState);
    }

    return (
        <div className={styles.header} ref={menu}>
            <div className={styles.bar}>
                <Logo />
                <HamburgerIcon className={styles.navToggle} onClick={handlenavToggleClick} opened={opened} />
            </div>
    
            <nav className={`${opened && styles.opened}`}>
                <Link to="/" state={{}}>Начало</Link>

                <Link to="/our-story">Нашата история</Link>
                
                <Link to="/wedding-party">Кумове & Шафери</Link>

                {/* <Link to="/our-story">Галерия</Link> */}

                <Link to="/faq">FAQ</Link>

                <Link to="/#rsvp" state={{targetId: 'rsvp'}} className={styles.buttonLink}><Button small>RSVP</Button></Link>
            
                {isMobile && !isTablet ? <AddToCalendarButtons /> : undefined}
            </nav>
        </div>
    );
};

export default HeaderMenu;